import { render, staticRenderFns } from "./detailVideoWH.vue?vue&type=template&id=bfa38982&scoped=true"
import script from "./detailVideoWH.vue?vue&type=script&lang=js"
export * from "./detailVideoWH.vue?vue&type=script&lang=js"
import style0 from "./detailVideoWH.vue?vue&type=style&index=0&id=bfa38982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa38982",
  null
  
)

export default component.exports